import { createContext, useContext } from 'react';
export const ClientContext = createContext({
    getClient: () => Promise.resolve(undefined),
    getInitialClient: () => Promise.resolve(undefined),
    queryClients: () => Promise.resolve(undefined),
});
export const useClientContext = () => {
    const context = useContext(ClientContext);
    if (context === null) {
        throw new Error('useClientContext must be used within a ClientProvider');
    }
    return context;
};
